import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import ServiceFaq from "./ServiceFaq";

// Service Images
import img01 from "../../images/service/img01.jpg";
import img02 from "../../images/service/img02.jpg";
import img03 from "../../images/service/img03.jpg";
import img04 from "../../images/service/img04.jpg";
import img05 from "../../images/service/img05.jpg";
import img06 from "../../images/service/img06.jpg";
import img13 from "../../images/service/img13.jpg";

const serviceImages: Record<number, string> = {
  1: img01,
  2: img02,
  3: img03,
  4: img04,
  5: img05,
  6: img06,
};

interface ServiceItem {
  id: number;
  slug: string;
  title: string;
  shortDesc: string;
  fullDesc: string;
  features: string[];
}

interface ServiceDetailsProps {
  currentService?: ServiceItem;
}

const ServiceDetails: React.FC<ServiceDetailsProps> = ({ currentService }) => {
  const { t } = useLanguage();

  const activeService = currentService || t.services.items[0];
  const serviceImg = serviceImages[activeService.id] || img13;

  const outcomeItems = t.serviceDetails.outcomesList;

  return (
    <section className="service-details pos-rel pb-90">
      <div className="container">
        {/* ========= ALL SERVICES NAVIGATION PILLS ========= */}
        <div className="mb-50">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
              padding: "16px 20px",
              borderRadius: "16px",
              background: "rgba(255, 255, 255, 0.03)",
              backdropFilter: "blur(12px)",
              border: "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            {t.services.items.map((srv) => {
              const isActive = srv.slug === activeService.slug;
              return (
                <Link
                  key={srv.id}
                  to={`/service-details/${srv.slug}`}
                  style={{
                    padding: "8px 18px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: 600,
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                    backgroundColor: isActive ? "#00FF97" : "rgba(255, 255, 255, 0.06)",
                    color: isActive ? "#00020F" : "rgba(255, 255, 255, 0.8)",
                    border: isActive
                      ? "1px solid #00FF97"
                      : "1px solid rgba(255, 255, 255, 0.12)",
                    boxShadow: isActive ? "0 0 14px rgba(0, 255, 151, 0.35)" : "none",
                  }}
                >
                  {srv.title}
                </Link>
              );
            })}
          </div>
        </div>

        {/* ========= SERVICE IMAGE + VIDEO ========= */}
        <div className="single-item-image service-det-img mb-60 pos-rel">
          <img
            src={serviceImg}
            alt={activeService.title}
            style={{
              width: "100%",
              maxHeight: "480px",
              objectFit: "cover",
              borderRadius: "16px",
            }}
          />

          {/* <button
            className="popup-video btn-video btn-video-center"
            onClick={openVideo}
            aria-label="Play video demo"
          >
            <span>
              <svg
                width="27"
                height="30"
                viewBox="0 0 27 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.0957 13.268C26.429 14.0378 26.429 15.9623 25.0957 16.7321L3.95285 28.9389C2.61951 29.7087 0.952845 28.7465 0.952845 27.2069L0.952846 2.79319C0.952846 1.25359 2.61951 0.291337 3.95285 1.06114L25.0957 13.268Z"
                  fill="#00020F"
                />
              </svg>
            </span>
          </button> */}
        </div>

        {/* ========= TITLE & OVERVIEW ========= */}
        <div className="mb-50">
          <span
            style={{
              color: "#00FF97",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "uppercase",
              letterSpacing: "1px",
              display: "inline-block",
              marginBottom: "8px",
            }}
          >
            {t.serviceDetails.overviewBadge}
          </span>
          <h2 className="details-content-title mb-20" style={{ fontSize: "clamp(26px, 3.5vw, 42px)" }}>
            {activeService.title}
          </h2>

          <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.9)" }}>
            {activeService.fullDesc}
          </p>

          <p className="mt-20" style={{ fontSize: "1.05rem", lineHeight: "1.8", color: "rgba(255,255,255,0.75)" }}>
            {activeService.shortDesc}
          </p>
        </div>

        {/* ========= CORE CAPABILITIES / FEATURES GRID ========= */}
        <div className="mb-70">
          <h3 className="details-content-title mb-25" style={{ fontSize: "24px" }}>
            {t.serviceDetails.featuresTitle}
          </h3>
          <div className="row g-3">
            {activeService.features.map((feature, i) => (
              <div className="col-md-6 col-lg-3" key={i}>
                <div
                  style={{
                    height: "100%",
                    padding: "22px 18px",
                    borderRadius: "12px",
                    background: "rgba(255, 255, 255, 0.03)",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <span
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(0, 255, 151, 0.15)",
                      border: "1px solid rgba(0, 255, 151, 0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      color: "#00FF97",
                    }}
                  >
                    <i className="far fa-check" style={{ fontSize: "14px" }}></i>
                  </span>
                  <span style={{ fontSize: "15px", fontWeight: 600, color: "#fff" }}>
                    {feature}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ========= SERVICE PROCESS FAQ ========= */}
        <ServiceFaq />

        {/* ========= SERVICES OUTCOME ========= */}
        <div className="services-outcome-wrap mb-90">
          <h2 className="details-content-title mb-15">
            {t.serviceDetails.outcomesTitle}
          </h2>
          <p>
            {t.serviceDetails.outcomesIntro}
          </p>

          <ul className="service-outcome-list list-unstyled mt-35">
            {outcomeItems.map((item, i) => (
              <li key={i}>
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.2"
                      d="M24 12C24 13.024 22.742 13.868 22.49 14.812C22.23 15.788 22.888 17.148 22.394 18.002C21.892 18.87 20.382 18.974 19.678 19.678C18.974 20.382 18.87 21.892 18.002 22.394C17.148 22.888 15.788 22.23 14.812 22.49C13.868 22.742 13.024 24 12 24C10.976 24 10.132 22.742 9.188 22.49C8.212 22.23 6.852 22.888 5.998 22.394C5.13 21.892 5.026 20.382 4.322 19.678C3.618 18.974 2.108 18.87 1.606 18.002C1.112 17.148 1.77 15.788 1.51 14.812C1.258 13.868 0 13.024 0 12C0 10.976 1.258 10.132 1.51 9.188C1.77 8.212 1.112 6.852 1.606 5.998C2.108 5.13 3.618 5.026 4.322 4.322C5.026 3.618 5.13 2.108 5.998 1.606C6.852 1.112 8.212 1.77 9.188 1.51C10.132 1.258 10.976 0 12 0C13.024 0 13.868 1.258 14.812 1.51C15.788 1.77 17.148 1.112 18.002 1.606C18.87 2.108 18.974 3.618 19.678 4.322C20.382 5.026 21.892 5.13 22.394 5.998C22.888 6.852 22.23 8.212 22.49 9.188C22.742 10.132 24 10.976 24 12Z"
                      fill="#00FF97"
                    />
                    <path
                      d="M15.5559 9.14076L11.3992 13.178L9.24437 11.0869C8.77664 10.6326 8.01773 10.6326 7.55001 11.0869C7.08229 11.5412 7.08229 12.2783 7.55001 12.7326L10.5729 15.6686C11.0279 16.1105 11.7668 16.1105 12.2218 15.6686L17.2484 10.7864C17.7162 10.3321 17.7162 9.59504 17.2484 9.14076C16.7807 8.68648 16.0236 8.68648 15.5559 9.14076Z"
                      fill="#00FF97"
                    />
                  </svg>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* ========= GALLERY ========= */}
        {/* <GallerySection /> */}

        {/* ========= CTA CONSULTATION ========= */}
        <div
          className="text-center mt-70 p-5"
          style={{
            borderRadius: "20px",
            background: "linear-gradient(135deg, rgba(0, 255, 151, 0.08) 0%, rgba(0, 2, 15, 0.6) 100%)",
            border: "1px solid rgba(0, 255, 151, 0.25)",
            backdropFilter: "blur(16px)",
          }}
        >
          <h3 style={{ color: "#fff", fontSize: "28px", fontWeight: 700, marginBottom: "12px" }}>
            {t.serviceDetails.ctaTitle}
          </h3>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "16px", maxWidth: "600px", margin: "0 auto 25px" }}>
            {t.serviceDetails.ctaDesc}
          </p>
          <Link to="/contact" className="thm-btn agency-btn">
            <span className="text">{t.nav.consultation}</span>
          </Link>
        </div>
      </div>

      {/* Video Modal */}
      {/* {isOpen && (
        <div
          className="video-popup-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeVideo}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div
            className="video-popup"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "min(900px, 90vw)",
              aspectRatio: "16 / 9",
              background: "#000",
              borderRadius: 12,
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            }}
          >
            <iframe
              ref={iframeRef}
              title="AI Integration Video"
              width="100%"
              height="100%"
              src="about:blank"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              frameBorder={0}
            />
            <button
              onClick={closeVideo}
              aria-label="Close video"
              style={{
                position: "absolute",
                top: 10,
                right: 14,
                background: "transparent",
                color: "#fff",
                border: 0,
                fontSize: 24,
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default ServiceDetails;
